import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';

class ArticleImg extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
        getImgCurrentIndex: PropTypes.func,
    };

    render() {
        const { content, getImgCurrentIndex } = this.props;
        const loadlazyImag = 'https://x0.ifengimg.com/cmpp/2020/0602/83ea75648508d97size0_w16_h9.jpg';

        return (
            <Fragment>
                <p>
                    <LazyImg
                        onClick={() => {
                            getImgCurrentIndex(content.src);
                        }}
                        className="swiperImg"
                        placeholder={loadlazyImag}
                        src={content.staticSrc || content.src}
                        data-src={content.src}
                    />
                </p>
            </Fragment>
        );
    }
}

export default ArticleImg;
